import { render } from "./ModalStatusAssinaturaDeclaracoes_PJ_Fundos.vue?vue&type=template&id=6ccd5414"
import script from "./ModalStatusAssinaturaDeclaracoes_PJ_Fundos.vue?vue&type=script&lang=js"
export * from "./ModalStatusAssinaturaDeclaracoes_PJ_Fundos.vue?vue&type=script&lang=js"

import "./ModalStatusAssinaturaDeclaracoes_PJ_Fundos.vue?vue&type=style&index=0&id=6ccd5414&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__